import script from "./TransactionsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsRow.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsRow.vue?vue&type=style&index=0&id=f5c90840&lang=css"

const __exports__ = script;

export default __exports__